<template>
<select class="form-control" :id="id" v-model="this.model" @change="dataChanged">
  <option v-for="(list, index) in lists" :key="index" :value="list[value]">{{ list[title] }}</option>
</select>
</template>

<script>
export default {
  props: ['id', 'lists', 'model', 'value', 'title', 'keyName'],
  data() {
    return {
      dataModel: this.model
    }
  },
  methods: {
    dataChanged(evt) {
      const newData = {
        [this.keyName]: evt.target.value
      }
      this.$emit('selectedChanged', newData)
    }
  }
}
</script>